// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__5FoY3","amountLabel":"styles_amountLabel__FYvFz","resetBtn":"styles_resetBtn__N2g2x"};